import { GetMethod, PostMethod } from '../../serviceHelper';

const getMethods = (service: 'main', controller: 'Permission') => ({
	Get: new PostMethod<any, any>({
		service,
		controller,
		method: 'Get'
	}),
	Update: new PostMethod<any, any>({
		service,
		controller,
		method: 'Update'
	}),
	GetUserPermissionScope: new GetMethod<any, any>({
		service,
		controller,
		method: 'GetUserPermissionScope'
	}),
	GetUserPermissionProjectsScope: new GetMethod<any, any>({
		service,
		controller,
		method: 'GetUserPermissionProjectsScope'
	}),
	GetObjectPermissions: new PostMethod<any, any>({
		service,
		controller,
		method: 'GetObjectPermissions'
	}),
	UpdateObjectPermissions: new PostMethod<any, any>({
		service,
		controller,
		method: 'UpdateObjectPermissions'
	}),
	ControlUserPermissions: new PostMethod<any, any>({
		service,
		controller,
		method: 'ControlUserPermissions'
	}),
	ListPermission: new PostMethod<any, any>({
		service,
		controller,
		method: 'ListPermission'
	}),
	ListPermissionPoolForProject: new PostMethod<any, any>({
		service,
		controller,
		method: 'ListPermissionPoolForProject'
	}),
	InsertPermission: new PostMethod<any, any>({
		service,
		controller,
		method: 'InsertPermission'
	}),
	EditPermission: new PostMethod<any, any>({
		service,
		controller,
		method: 'EditPermission'
	}),
	CheckRemovePermission: new PostMethod<any, any>({
		service,
		controller,
		method: 'CheckRemovePermission'
	}),
	RemovePermission: new PostMethod<any, any>({
		service,
		controller,
		method: 'RemovePermission'
	}),
	ListPermissionProjectMember: new PostMethod<any, any>({
		service,
		controller,
		method: 'ListPermissionProjectMember'
	}),
	InsertPermissionProjectMember: new PostMethod<any, any>({
		service,
		controller,
		method: 'InsertPermissionProjectMember'
	}),
	RemovePermissionProjectMember: new PostMethod<any, any>({
		service,
		controller,
		method: 'RemovePermissionProjectMember'
	})
});

export { getMethods };
